/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { makeStyles } from '@material-ui/core/styles';
// import RootedInLoveSVG from './RootedInLove'
const useStyles = makeStyles((theme) => ({
    holdTightContainer: {
        minHeight: 'calc(110vh - 496px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#B3261D',
        fontWeight: 400,
        '& div':{
            fontSize: '4.5rem !important',
            fontFamily: 'Playfair Display !important',
            fontWeight: '600',
            lineHeight: '5.5rem',
            letterSpacing: '0px',
            [theme.breakpoints.down('sm')]: {
                fontSize: '3.5rem !important',
                lineHeight: '4.12rem',
            },
        },
        [theme.breakpoints.down('sm')]: {
            minHeight: 'calc(110vh - 236px)',
        },
        '& .holdTightIcon':{
            [theme.breakpoints.down('sm')]: {
                fontSize: '2.5rem !important',
            
            },
        },
        '& .holdTightText':{
            marginTop: '5px',
            [theme.breakpoints.down('sm')]: {
                width: '181px',
                textAlign: 'center' 
            },
            
        }},
}));
const PlayBookLoader = () => {
    const classes = useStyles();
    return (
        <>
            <div className={classes.holdTightContainer}>
                <div className='holdTightIcon'>
                    ⏳🪄❤️‍🔥
                </div>
                <div className='holdTightText'>
                    HOLD TIGHT!
                </div>
                
            </div>
            {/* <div id='rootedInSvgIcon'>
                <RootedInLoveSVG />
            </div> */}
            </>
    )
};

export default PlayBookLoader;